import * as _ from 'lodash';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import RHFCheckbox from 'src/components/controls/tempRHFControls/RHFCheckBox';
import React, { useState, useEffect } from 'react';
import { ODataOptions, ODataFilter, ODataFilterOperators, ODataOrderByDirection } from 'src/util/ODataBuilder';
import FindClientDialog from  'src/components/client-project/dialogs/FindClientDialog';
import { ITableConfig } from 'src/components/common/table';
import useFetch from 'use-http';
import CPNavBar from '../CPNavBar';
import { useForm } from 'react-hook-form';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import Page from 'src/components/common/Page';
import Panel from 'src/components/common/Panel';
import State from 'src/models/State';
import Button from 'src/components/controls/forms/redesign/FormButton';
import ClientProjectSearch from 'src/components/project-billing/components/ClientProjectSearch';
import PagedResultSet from 'src/models/common/PagedResultSet';
import TsdiClient from 'src/models/AP/Client';
import { BiAddToQueue, BiLeftArrowAlt, BiRightArrowAlt, BiArrowToLeft, BiArrowToRight } from 'react-icons/bi';
import { MdHistory } from 'react-icons/md';
import { FaTrash } from 'react-icons/fa';
import { FaUserTie } from 'react-icons/fa';
import { FaRegSave } from 'react-icons/fa';
import { FaFileAlt } from 'react-icons/fa';
import { VscGraph } from 'react-icons/vsc';
import DialogList from 'src/dialogs';
import actions from 'src/actions';
import { useDispatch } from 'react-redux';
import ProspectDetails from 'src/models/projectSettings/TsdiProspect';
import ProspectStaff from 'src/models/projectSettings/TsdiProspectStaff';
import FindProjectDialog from '../dialogs/FindProjectDialog';
import FindProjectStaffDialog from '../dialogs/FindProjectStaffDialog';
import FindLandmanDialog from '../dialogs/FindProjectStaffDialog';
import { AnyObject } from 'final-form';
import PayPeriod from 'src/models/AP/PayPeriod';
import TsdiLandman from 'src/models/projectSettings/TsdiLandman';

const ProjectStaffingPage = () => {
    const dispatch = useDispatch();
    const { register, errors} = useForm();
    const { register: registerStaffingListValues, getValues: getStaffingListValues } = useForm();
    const { register: registerClientValues, reset: resetClientValues } = useForm();
    const { get, post, put, del, response } = useFetch();
    const [projects, setProjects] = useState<ProspectDetails[]>(undefined);
    const [projectTypes, setProjectTypes] = useState<{ code: number, description: string}[]>(undefined);
    const [currentMileageRate, setCurrentMileageRate] = useState<number>(undefined);
    const [clients, setClients] = useState<Array<TsdiClient>>(undefined);
    const [states, setStates] = useState<PagedResultSet<State>>(undefined);
    const [selectStates, setSelectStates] =  useState<Array<{ value: string; label: string }>>(undefined);
    const [clientSearchOptions, setClientSearchOptions] = useState<ODataOptions>(undefined);
    const [projectSearchOptions, setProjectSearchOptions] = useState<ODataOptions>(undefined);
    const [staffingLandmanSearchOptions, setStaffingLandmanSearchOptions] = useState<ODataOptions>(undefined);
    const [clientSearchTerm, setClientSearchTerm] = useState<string>('');
    const [projectSearchTerm, setProjectSearchTerm] = useState<string>('');
    const [projectStaffSearchTerm, setProjectStaffSearchTerm] = useState<string>('');
    const [landmanSearchTerm, setLandmanSearchTerm] = useState<string>('');
    const [fetchNextClientsPage, setFetchNextClientsPage] = useState<boolean>(true);
    const [fetchNextProjectsPage, setFetchNextProjectsPage] = useState<boolean>(true);
    const [selectedClient, setSelectedClient] = useState<TsdiClient>(undefined);
    const [selectedProject, setSelectedProject] = useState<ProspectDetails>(undefined);
    const [addingStaff, setAddingStaff] = useState<boolean>(false);
    const [landmanSearchOptions, setLandmanSearchOptions] = useState<ODataOptions>(undefined);
    const [staffingLandmen, setStaffingLandmen] = useState<Array<ProspectStaff>>(undefined);
    const [landmen, setLandmen] = useState<Array<TsdiLandman>>(undefined);
    const [selectedProjectStaff, setSelectedProjectStaff] = useState<ProspectStaff>(undefined);
    const [selectedLandman, setSelectedLandman] = useState<TsdiLandman>(undefined);
    const [payPeriods, setPayPeriods] = useState<Array<{value: number | string, label: string}>>(undefined);
    const [workClassifications, setWorkClassifications] = useState<Array<{value: number | string, label: string}>>(undefined);
    // const { isDirty, dirtyFields } = formState;

    // Initial render
    useEffect(() => {
        onCreate();

        // TODO: *cry* 😭✅
        return () => {
            onDestroy();
        };
    }, []);

    useEffect(() => {
        if (!!clientSearchOptions) {
            getClients();
        }
    }, [clientSearchOptions]);

    useEffect(() => {
        if (!!selectedProjectStaff) {
            addProjectStaff(generateAddStaffPayload(selectedProjectStaff));
        }
    }, [selectedProjectStaff]);

    useEffect(() => {
        if (!!landmanSearchTerm) {
            resetLandmanSearchSettings();
        }
    }, [landmanSearchTerm]);

    useEffect(() => {
        if (!!projectSearchOptions) {
            getProjects();
        }
    }, [projectSearchOptions]);

    useEffect(() => {
        if (!!addingStaff) {
            showDialog(DialogList.FIND_PROJECT_STAFF);
        }
    }, [addingStaff]);

    useEffect(() => {
        if (states?.items?.length) {

            let list = states?.items?.map(s => {
                return {
                    label: (!!s.name ? `(${s.name})` : ''),
                    value: `${s.id}` };
            });
            setSelectStates(list);
        }
    }, [states]);

    useEffect(() => {
        if (!!selectStates) {
            console.log(selectStates[0]);
        }
    }, [selectStates]);

    useEffect(() => {
        if (!!landmanSearchOptions) {
            getLandmen();
        }
    }, [landmanSearchOptions]);

    useEffect(() => {
        if ((!!clientSearchTerm || clientSearchTerm === '') && !!clientSearchOptions) {
            resetClientSearchOptions();
        }
    }, [clientSearchTerm]);

    useEffect(() => {
        if (!!projectStaffSearchTerm || projectStaffSearchTerm === '') {
            resetStaffingLandmanSearchSettings();
        }
    }, [projectStaffSearchTerm]);

    useEffect(() => {
        if ((!!projectSearchTerm || projectSearchTerm === '') && !!projectSearchOptions) {
            resetProjectSearchOptions();
        }
    }, [projectSearchTerm]);

    useEffect(() => {
        getClients();
    }, [clientSearchOptions]);

    useEffect(() => {
        if (!!staffingLandmanSearchOptions) {
            getStaffingLandmen();
        }
    }, [staffingLandmanSearchOptions]);

    useEffect(() => {
        if (!!clients && clients.length > 0) {
            prepFormData();
        }
    }, [clients]);

    useEffect(() => {
        if (!!selectedClient) {
            if (!!clients && clients?.length > 0) {
                resetClientValues({ clientNumber: selectedClient?.clientNumber, clientName: selectedClient?.clientName });
            }
        }
    }, [selectedClient]);

    useEffect(() => {
        if (!!selectedProject) {
            if (!!selectedClient?.clientNumber && !!selectedClient?.clientName) {
                resetClientValues({ clientNumber: selectedClient.clientNumber, clientName: selectedClient.clientName, projectNumber: selectedProject.number, projectName: selectedProject.name});
                getStaffingLandmen();
            }
        }
    }, [selectedProject]);

    const onCreate = () => {
        // Todo: Remove!!
        console.log(selectedLandman);
        console.log(landmanSearchTerm);
        // Put all initialization code here.
        initializeClientSearchSettings();        
        initializeLandmanSearchSettings();
        initializeStaffingLandmanSearchSettings();
        getPayPeriods();
        getWorkClassifications();
        getStates();
        getClientTypes();
        if (!projects) {
            setProjects([]);
        }
        getCurrentMileageRate();
    };

    const initializeStaffingLandmanSearchSettings = () => {
        const tableConfig: ITableConfig = {
            rowCount: 50,
            idField: 'lm.LM_NO',
            pageNumber: 1,
            columns: []
        };
        // tslint:disable-next-line:max-line-length
        const newDataOptions = ODataOptions.from(tableConfig).addOrderBy('lm.LNAME', ODataOrderByDirection.Ascending);
        setStaffingLandmanSearchOptions(newDataOptions);
    };

    const initializeLandmanSearchSettings = () => {
        const tableConfig: ITableConfig = {
            rowCount: 50,
            idField: 'lm.LNAME',
            pageNumber: 1,
            columns: []
        };
        // tslint:disable-next-line:max-line-length
        const newDataOptions = ODataOptions.from(tableConfig).addOrderBy('lm.LNAME', ODataOrderByDirection.Ascending);
        setLandmanSearchOptions(newDataOptions);
    };

    const getProjects = async () => {
        if (clients === undefined || clients?.length < 1) {
            return;
        }
        const clientIndex = clients?.findIndex((c) => c?.clientNumber === selectedClient?.clientNumber);
        if (clientIndex === -1) {
            return;
        }
        let result = await get(`/v1.0/ClientProjectMaintenance/projects/byclient/${clients[clientIndex].clientNumber}`);

        if (response.ok) {
            setProjects([]);
            setProjects(result);
        } else {
            setProjects([]);
            console.log('Unable to get client data!');
        }
    };

    const getCurrentMileageRate = async () => {
        let result = await get(`/v1.0/ClientProjectMaintenance/client/billing/mileagerate/current`);

        if (response.ok) {
            setCurrentMileageRate(result);
        } else {
            setCurrentMileageRate(.7);
            console.log('Unable to get mileage rate!');
        }
    };

    const onDestroy = () => {
        // Put all destruction code here.
    };

    const hideDialog = () => {
        setAddingStaff(false);
        dispatch(actions.layout.hideDialog());
    };

    const onCancel = () => {
        setAddingStaff(false);
        dispatch(actions.layout.hideDialog());
    };

    const getClients = async () => {
        const queryString = clientSearchOptions?.toString();
        let result = await get(`/v1.0/AccountsPayable/clients${queryString}`);

        if (response.ok) {
            setClients([]);
            setClients(result.items);
            // Todo: get this from the DB and set it when the client is set from FindClientsDialog
        } else {
            setClients([]);
            console.log('Unable to get client data!');
        }
    };

    const initializeClientSearchSettings = () => {
        const tableConfig: ITableConfig = {
            rowCount: 100,
            idField: 'CL_NO',
            pageNumber: 1,
            columns: []
        };
        setClientSearchOptions(ODataOptions.from(tableConfig).addOrderBy('NAME1', ODataOrderByDirection.Ascending));
    };

    const prepFormData = () => {
        if (!!clients && clients?.length > 0) {
            console.log(clients[0]);
        }
    };

    const getStates = async () => {
        const result = await get(`/v1.0/states`);

        if (response.ok) {
            setStates(result);
        } else {
            console.log('Unable to retrieve States data.');
        }
    };

    const getStaffingLandmen = async () => {
        const projectId = !!selectedProject?.id ? selectedProject.id : undefined;
        if (!!staffingLandmanSearchOptions && !!projectId) {
            let queryString = !!staffingLandmanSearchOptions?.toString() ? staffingLandmanSearchOptions?.toString() : '';
            let result = await get(`/v1.0/ClientProjectMaintenance/project/${projectId}/staffing/landmen${queryString}`);

            if (response.ok) {
                setStaffingLandmen(result?.items);
            } else {
                console.log('Unable to get client landmen Data!');
            }
        }
    };

    const getLandmen = async () => {
        if (!!landmanSearchOptions) {
            let queryString = !!landmanSearchOptions?.toString() ? landmanSearchOptions?.toString() : '';
            let result = await get(`/v1.0/ClientProjectMaintenance/staffing/landmen${queryString}`);

            if (response.ok) {
                setLandmen(result?.items);
            } else {
                console.log('Unable to get client landmen Data!');
            }
        }
    };

    const deleteProject = () => {
        alert('Delete a project');
    };

    const displayTitle = () => {
        const title = 'Project Staffing';

        return title;
    };

    const displayHeading2 = () => {
        const title = 'Project Staff';

        return title;
    };

    const addProjectStaff = async (payload: ProspectStaff) => {
        let result = await post(`/v1.0/ClientProjectMaintenance/project/staff`, payload);

        if (response.ok && result === 1) {
            getStaffingLandmen();
        }
    };

    const updateProjectStaff = async (payload: ProspectStaff) => {
        let result = await put(`/v1.0/ClientProjectMaintenance/project/staff`, payload);

        if (response.ok && result === 1) {
            getStaffingLandmen();
        }
    };

    const removeProjectStaff = async (projectId: number, tsdiNumber: number) => {
        let result = await del(`/v1.0/ClientProjectMaintenance/project/staff/projectId/${projectId}/tsdiNumber/${tsdiNumber}`);

        if (response.ok && result === 1) {
            getStaffingLandmen();
        }
    };

    const getClientTypes = async () => {
        let result = await get(`/v1.0/ClientProjectMaintenance/clients/types`);
        setProjectTypes([]);
        if (response.ok) {
            setProjectTypes(result);
        }
    };

    const resetStaffingLandmanSearchSettings = () => {
        let newPersionSearchOptions = !!staffingLandmanSearchOptions ? _.cloneDeep(staffingLandmanSearchOptions) : new ODataOptions();
        setStaffingLandmanSearchOptions(newPersionSearchOptions);
    };

    const resetLandmanSearchSettings = () => {
        let newPersionSearchOptions = !!landmanSearchOptions ? _.cloneDeep(landmanSearchOptions) : new ODataOptions();
        newPersionSearchOptions.clearFilters();
        newPersionSearchOptions.addPaging(1, 50);
        newPersionSearchOptions.setIsNextpage(true);
        if (typeof landmanSearchTerm === 'string') {
            const fieldValues = landmanSearchTerm.split(',');
            if (fieldValues[0] !== undefined && !isNaN(Number(fieldValues[0])) && Number(fieldValues[0]) !== 0) {
                newPersionSearchOptions.addFilter(new ODataFilter('TSD_NO', ODataFilterOperators.Equals, !!landmanSearchTerm ? fieldValues[0] : ''));
            } else if (fieldValues.length === 1 && !!fieldValues[0]) {
                // No comma was typed at all - treat the single token as a last-name search
                // instead of silently dropping it, which produced a zero-filter query that
                // returned every landman.
                newPersionSearchOptions.addFilter(new ODataFilter('LNAME', ODataFilterOperators.Contains, fieldValues[0]));
            }
            if (fieldValues[1] !== undefined) {
                const filterValue = !!landmanSearchTerm ? fieldValues[1] : '';
                if (filterValue !== '') {
                    newPersionSearchOptions.addFilter(new ODataFilter('LNAME', ODataFilterOperators.Contains, !!landmanSearchTerm ? fieldValues[1] : ''));
                }
            }
            if (fieldValues[2] !== undefined) {
                const filterValue = !!landmanSearchTerm ? fieldValues[2] : '';
                if (filterValue !== '') {
                    newPersionSearchOptions.addFilter(new ODataFilter('FNAME', ODataFilterOperators.Contains, !!landmanSearchTerm ? fieldValues[2] : ''));
                }
            }
        }

        setLandmanSearchOptions(newPersionSearchOptions);
    };

    const resetClientSearchOptions = () => {
        setFetchNextClientsPage(true);
        console.log(fetchNextClientsPage);
        let newClientSearchOptions = _.cloneDeep(clientSearchOptions);
        newClientSearchOptions.clearFilters();
        newClientSearchOptions.addPaging(1, 50);
        if (typeof clientSearchTerm === 'string') {
            const fieldValues = clientSearchTerm.split(',');
            if (fieldValues[0] !== undefined && !isNaN(Number(fieldValues[0]))) {
                newClientSearchOptions.addFilter(new ODataFilter('CL_NO', ODataFilterOperators.Equals, !!clientSearchTerm ? fieldValues[0] : ''));
            }
            if (fieldValues[1] !== undefined) {
                newClientSearchOptions.addFilter(new ODataFilter('NAME1', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[1] : ''));
            }
            if (fieldValues[2] !== undefined) {
                newClientSearchOptions.addFilter(new ODataFilter('NAME2', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[2] : ''));
            }
            if (fieldValues[3] !== undefined) {
                newClientSearchOptions.addFilter(new ODataFilter('CITY', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[3] : ''));
            }
            if (fieldValues[4] !== undefined) {
                newClientSearchOptions.addFilter(new ODataFilter('STATE', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[4] : ''));
            }
            if (fieldValues[5] !== undefined) {
                newClientSearchOptions.addFilter(new ODataFilter('ZIP', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[5] : ''));
            }
            if (fieldValues[6] !== undefined) {
                newClientSearchOptions.addFilter(new ODataFilter('PHONE', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[6] : ''));
            }
        }
        setClientSearchOptions(newClientSearchOptions);
    };

    const resetProjectSearchOptions = () => {
        setFetchNextProjectsPage(true);
        console.log(fetchNextProjectsPage);
        let newProjectSearchOptions = _.cloneDeep(projectSearchOptions);
        newProjectSearchOptions.clearFilters();
        newProjectSearchOptions.addPaging(1, 50);
        if (typeof projectSearchTerm === 'string') {
            const fieldValues = projectSearchTerm.split(',');
            if (fieldValues[0] !== undefined && !isNaN(Number(fieldValues[0]))) {
                newProjectSearchOptions.addFilter(new ODataFilter('[CL_NO]', ODataFilterOperators.Equals, !!projectSearchTerm ? fieldValues[0] : ''));
            }
            if (fieldValues[1] !== undefined && !isNaN(Number(fieldValues[1]))) {
                newProjectSearchOptions.addFilter(new ODataFilter('[PR_NO]', ODataFilterOperators.Equals, !!projectSearchTerm ? fieldValues[1] : ''));
            }
            if (fieldValues[2] !== undefined && !isNaN(Number(fieldValues[2]))) {
                newProjectSearchOptions.addFilter(new ODataFilter('[PR_NAME]', ODataFilterOperators.Contains, !!projectSearchTerm ? fieldValues[2] : ''));
            }
            if (fieldValues[3] !== undefined && !isNaN(Number(fieldValues[3]))) {
                newProjectSearchOptions.addFilter(new ODataFilter('[TSD_MGR]', ODataFilterOperators.Contains, !!projectSearchTerm ? fieldValues[3] : ''));
            }
            if (fieldValues[4] !== undefined && !isNaN(Number(fieldValues[4]))) {
                newProjectSearchOptions.addFilter(new ODataFilter('[PROJECT_COORDINATOR]', ODataFilterOperators.Contains, !!projectSearchTerm ? fieldValues[4] : ''));
            }
            if (fieldValues[5] !== undefined && !isNaN(Number(fieldValues[5]))) {
                newProjectSearchOptions.addFilter(new ODataFilter('[OFFICE]', ODataFilterOperators.Contains, !!projectSearchTerm ? fieldValues[5] : ''));
            }
        }
        setProjectSearchOptions(newProjectSearchOptions);
    };

    const handleUnstaffLandman = (projectId: number, tsdiNumber: number) => {
        removeProjectStaff(projectId, tsdiNumber);
    };

    const displayProjectSettingButtons = () => {
        return (
            <>
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Move to First Project"
                    reactIcon={BiArrowToLeft}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => moveToFirstProject()}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Move to Previous Project"
                    reactIcon={BiLeftArrowAlt}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => moveToPreviousProject()}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Add Staff"
                    reactIcon={BiAddToQueue}
                    iconHoverColor="blue"
                    iconStyle={{width: '2.5rem', height: '2.5rem', verticalAlign: 'center'}}
                    onClick={() => setAddingStaff(true)}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Delete Project"
                    reactIcon={FaTrash}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => deleteProject()}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Save Staffing Changes"
                    reactIcon={FaRegSave}
                    type={'button'}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => onSaveChanges()}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Move to Next Project"
                    reactIcon={BiRightArrowAlt}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => moveToNextProject()}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Move to Last Project"
                    reactIcon={BiArrowToRight}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => moveToLastProject()}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Change Manager"
                    reactIcon={FaUserTie}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => findPerson()}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Manager Change History"
                    reactIcon={FaUserTie}
                    iconHoverColor="blue"
                    iconStyle={{fill: 'rgb(99, 147, 193)', width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => showManagerChangeHistory()}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="PCM Change History"
                    reactIcon={MdHistory}
                    iconHoverColor="blue"
                    iconStyle={{fill: 'rgb(99, 147, 193)', width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => showApmChangeHistory()}
                />
            </>
        );
    };

    const displayProjectStaffingList = () => {
        return <div>
            <table className={'project-billing'}>
                <thead className={'project-billing'}>
                    <tr className={'project-billing'}>
                        <th style={{width: '2%'}}/>
                        <th style={{width: '3%'}}>Emp #</th>
                        <th style={{width: '8%'}}>Name</th>
                        <th style={{width: '4%'}}>Beg Period</th>
                        <th style={{width: '4%'}}>End Period</th>
                        <th style={{width: '3%'}}>Pay Rate</th>
                        <th style={{width: '3%'}}>Bill Rate</th>
                        <th style={{width: '3%'}}>Mgr #</th>
                        <th style={{width: '3%'}}>PC/APM</th>
                        <th style={{width: '10%'}}>Classification</th>
                        <th style={{width: '16%'}}>Access Permissions</th>
                    </tr>
                </thead>
                {!!staffingLandmen && staffingLandmen.length > 0 && staffingLandmen?.map(
                    (ps: ProspectStaff, index: number) => {
                    console.log('Staff Landman Id: ' + ps.id);
                    return (
                        <tbody key={ps?.id}>
                            <tr className="table-item-hover" style={{ textAlign: 'center' }}>
                                <td style={{ width: '2%' }}>
                                    <Button
                                        reactIcon={IoMdCloseCircleOutline}
                                        iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                        iconHoverColor="red"
                                        title="Unstaff"
                                        style={{ height: '3rem', background: 'transparent' }}
                                        onClick={() => handleUnstaffLandman(selectedProject.id, ps.tsdiEmployeeNumber)}
                                    />
                                </td>
                                <td style={{ width: '4%' }}>
                                    <RHFInputBox
                                        name={`staffingLandmen[${index}].tsdiEmployeeNumber`}
                                        type="number"
                                        defaultVal={ps?.tsdiEmployeeNumber?.toString()}
                                        register={registerStaffingListValues}
                                        errors={errors}
                                        style={{ width: '100%', background: '#d5f7f5' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '8%' }}>
                                    <RHFInputBox
                                        name={`staffingLandmen[${index}].aksName`}
                                        type="text"
                                        defaultVal={!!ps?.akaName && ps.akaName.length > 0 ? ps.akaName : ps.firstName + ' ' + ps.lastName}
                                        register={register}
                                        errors={errors}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '4%' }}>
                                    <RHFInputBox
                                        name={`staffingLandmen[${index}].begPeriod`}
                                        type="number"
                                        defaultVal={!!ps?.begPeriod ? ps?.begPeriod?.toString() : ''}
                                        register={register}
                                        errors={errors}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '3%' }}>
                                    <RHFInputBox
                                        name={`staffingLandmen[${index}].endPeriod`}
                                        type="text"
                                        defaultVal={!!ps?.endPeriod ? ps.endPeriod.toString() : ''}
                                        register={register}
                                        errors={errors}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{  width: '3%' }}>
                                    <RHFInputBox
                                        name={`staffingLandmen[${index}].payRate`}
                                        defaultVal={!!ps?.payRate ? ps.payRate.toString() : ''}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                        register={register}
                                        errors={errors}
                                    />
                                </td>
                                <td style={{ width: '3%' }}>
                                    <RHFInputBox
                                        name={`staffingLandmen[${index}].billRate`}
                                        defaultVal={!!ps?.billRate ? ps.billRate.toString() : ''}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                        register={register}
                                        errors={errors}
                                    />
                                </td>
                                <td style={{ width: '3%' }}>
                                    <RHFInputBox
                                        name={`staffingLandmen[${index}].managerNumber`}
                                        defaultVal={!!ps?.managerNumber ? ps.managerNumber.toString() : ''}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                        register={register}
                                        errors={errors}
                                    />
                                </td>
                                <td style={{ width: '3%' }}>
                                    <RHFInputBox
                                        name={`staffingLandmen[${index}].pcApmNumber`}
                                        defaultVal={!!ps?.pcApmNumber ? ps.pcApmNumber.toString() : ''}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                        register={register}
                                        errors={errors}
                                    />
                                </td>
                                <td style={{ width: '10%' }}>
                                    <RHFInputBox
                                        name={`staffingLandmen[${index}].catType`}
                                        defaultVal={!!ps?.catType ? ps.catType.toString() : ''}
                                        style={{ width: '100%'}}
                                        bodyStyle={{ width: '100%'}}
                                        register={register}
                                        errors={errors}
                                    />
                                </td>
                                <td style={{ width: '4%' }}>
                                    <RHFCheckbox
                                        label={'Ownerships'}
                                        name={`staffingLandmen[${index}].ownershipsAccess`}
                                        checked={!!ps?.ownershipAccess ? ps.ownershipAccess : false}
                                    />
                                </td>
                                <td style={{ width: '4%' }}>
                                    <RHFCheckbox
                                        label={'Draft Report'}
                                        name={`staffingLandmen[${index}].draftReport`}
                                        checked={!!ps?.draftReport ? ps.draftReport : false}
                                    />
                                </td>
                                <td style={{ width: '4%' }}>
                                    <RHFCheckbox
                                        label={'Contracts'}
                                        name={`staffingLandmen[${index}].contractsAccess`}
                                        checked={!!ps?.contractsAccess ? ps.contractsAccess : false}
                                    />
                                </td>
                                <td style={{ width: '4%' }}>
                                    <RHFCheckbox
                                        label={'Reports'}
                                        name={`staffingLandmen[${index}].reportsAccess`}
                                        checked={!!ps?.reportsAccess ? ps.reportsAccess : false}
                                    />
                                </td>
                                <td style={{ width: '4%' }}>
                                    <RHFCheckbox
                                        label={'GIS'}
                                        name={`staffingLandmen[${index}].webMapping`}
                                        checked={!!ps?.webMapping ? ps.webMapping : false}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    );
                })}
            </table>
        </div>;
    };

    const showDialog = (dialog: DialogList) => {
        dispatch(actions.layout.showDialog(dialog));
    };

    const findClient = () => {
        showDialog(DialogList.FIND_CLIENT);
    };

    const onSubmit = () => {
        console.log('onSubmit called for save project');
    };

    const findPerson = () => {
        getStaffingLandmen();
    };

    const showManagerChangeHistory = () => {
        alert('Implement manager change history dialog');
    };

    const showApmChangeHistory = () => {
        alert('Implement APM change history dialog');
    };

    const reportOptions = () => {
        alert('Implement report options');
    };

    const moveToFirstProject = () => {
        if (!!projects && projects?.length > 1) {
            setSelectedProject(projects[0]);
        }
    };

    const moveToNextProject = () => {
        alert('Implement move to next project');
    };

    const moveToLastProject = () => {
        if (!!projects && projects?.length > 1) {
            setSelectedProject(projects[projects.length - 1]);
        }
    };

    const generateAddStaffPayload = (formData: AnyObject) => {
/*         const payload: Partial<ProspectStaff> = {
            projectNumber: selectedProject.number,
            lmsAccess: formData.lmsAccess
        }; */

        return formData as ProspectStaff;
    };

    const onSaveChanges = () => {
        const staffingFormValues = getStaffingListValues() as Array<ProspectStaff>;
        for (let staffingListIndex = 0; staffingListIndex < staffingFormValues.length; staffingListIndex++) {
            updateProjectStaff(staffingFormValues[staffingListIndex]);
        }
    };

    const moveToPreviousProject = () => {
        alert('Implement move to previous project');
    };

    const generateReports = () => {
        alert('Implement reports.');
    };

    const prospectByManagerReport = () => {
        alert('Implement Prospect By Manager Report.');
    };

    const runQuery = () => {
        alert('Run query for client and project');
    };

    const getDayRate = () => {
        let dayRate = 250.00;
        if (!!addingStaff) {
            if (!!selectedClient && !!selectedClient?.dayRate) {
                dayRate = selectedClient.dayRate;
            }
        }
        return dayRate;
    };

    const initializePayPeriodSearchSettings = () => {
        const tableConfig: ITableConfig = {
            rowCount: 500,
            idField: 'Id',
            pageNumber: 1,
            columns: []
        };
        const payPeriodSearchOptions = ODataOptions.from(tableConfig);
        payPeriodSearchOptions.addOrderBy('Id', ODataOrderByDirection.Descending);
        const currentDate = new Date();
        const currentDate2 = new Date();
        const beginDate = new Date(currentDate.setMonth(currentDate.getMonth() - 6)).toLocaleDateString().replace('/', '-').replace('/', '-');
        const endDate = new Date(currentDate2.setMonth(currentDate2.getMonth() + 6)).toLocaleDateString().replace('/', '-').replace('/', '-');
        payPeriodSearchOptions?.addFilter(new ODataFilter('end_date', ODataFilterOperators.LessThan, endDate));
        payPeriodSearchOptions?.addFilter(new ODataFilter('beg_date', ODataFilterOperators.GreaterThan, beginDate));
        
        return payPeriodSearchOptions.toString();
    };

    const getPayPeriods = async () => {        
        const queryString = initializePayPeriodSearchSettings();
        let result = await get(`/v1.0/AccountsPayable/payperiods${queryString}`);

        if (response.ok) {
            setPayPeriods(result.items.map((pp: PayPeriod) => {
                const insertIndex = pp.periodNumber.toString().length - 2;
                const ppString = pp.periodNumber.toString().slice(0, insertIndex) + '-' + pp.periodNumber.toString().slice(insertIndex);
                return { value: pp.periodNumber, label: ppString };
            }));
        } else {
            console.log('Unable to get pay period data!!!');
        }
    };

    const getWorkClassifications = async () => {        
        let result = await get(`/v1.0/ClientProjectMaintenance/project/workclassifications`);

        if (response.ok && !!result && result?.length > 0 && (Array.isArray(result))) {
            setWorkClassifications(result?.map((wc: { code: number, description: string}) => {
                return { value: wc.code, label: wc.description };
            }));
        } else {
            console.log('Unable to get pay period data!!!');
        }
    };

    const handleSelectedPerson = async (person: ProspectStaff) => {
        person.clientNumber = selectedClient.clientNumber;
        setSelectedProjectStaff(person);
    };

    return (
        <>
        <div>
        <CPNavBar/>
        <ClientProjectSearch
            setSelectedClient={setSelectedClient}
            setSelectedProject={setSelectedProject}
            clients={clients}
            projects={true}
            runQuery={runQuery}
            size={6}
        />
           <div style={{display: 'flex', flexDirection: 'column', width: '100vw', justifyContent: 'center'}}>
            <div style={{width: '100%'}}>
                <Page className="dlc-maxer-width">
                        <Page.Section width={14}>
                            <Panel backgroundColor="#D3D3D3">
                                <Panel panelTitle={displayTitle()}>
                                    <div style={{ border: 'solid rgb(99, 147, 193) 1px', padding: '.5rem' }}>
                                    <form id={`ProjectStaffingForm`} onSubmit={onSubmit}>
                                        <div className="form-row" style={{ marginBottom: '0' }}>
                                            <RHFInputBox
                                                name={'clientNumber'}
                                                style={{width: '100%'}}
                                                bodyStyle={{width: '15%'}}
                                                register={registerClientValues}
                                                readOnly={true}
                                            />
                                            <RHFInputBox
                                                name={'clientName'}
                                                style={{width: '100%'}}
                                                bodyStyle={{width: '70%'}}
                                                register={registerClientValues}
                                                readOnly={true}
                                            />
                                            <RHFInputBox
                                                name={'projectNumber'}
                                                style={{width: '100%'}}
                                                bodyStyle={{width: '15%'}}
                                                register={registerClientValues}
                                                readOnly={true}
                                            />
                                            <RHFInputBox
                                                name={'projectName'}
                                                style={{width: '100%'}}
                                                bodyStyle={{width: '70%'}}
                                                register={registerClientValues}
                                                readOnly={true}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Reports"
                                                reactIcon={VscGraph}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center', marginTop: '.4rem'}}
                                                onClick={() => reportOptions()}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Add New Client"
                                                reactIcon={BiAddToQueue}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2.5rem', height: '2.5rem', verticalAlign: 'center'}}
                                                onClick={() => findClient()}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Move to First Record"
                                                reactIcon={BiArrowToLeft}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => moveToFirstProject}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Move to Previous Record"
                                                reactIcon={BiLeftArrowAlt}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={moveToPreviousProject}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Move to Next Record"
                                                reactIcon={BiRightArrowAlt}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={moveToNextProject}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Move to Last Record"
                                                reactIcon={BiArrowToRight}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={moveToLastProject}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Billing Accounts"
                                                reactIcon={FaFileAlt}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => generateReports()}
                                            />
                                            <a style={{ display: 'hidden' }} id="a_voucherCheck" />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Prospect by Manager"
                                                reactIcon={FaUserTie}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => prospectByManagerReport()}
                                            />
                                        </div>
                                        </form>
                                    </div>
                                </Panel>
                            </Panel>
                        </Page.Section>
                    </Page>
                    <Page className="dlc-maxer-width">
                        <Page.Section width={14}>
                            <Panel backgroundColor="#D3D3D3">
                                <Panel panelTitle={displayHeading2()}>
                                    <div style={{marginBottom: '1rem', display: 'flex', width: '100%', justifyContent: 'center'}}>
                                        {displayProjectSettingButtons()}
                                    </div>
                                    <div style={{ border: 'solid rgb(99, 147, 193) 1px', paddingBottom: '.5rem' }}>
                                        <form>
                                            {displayProjectStaffingList()}
                                        </form>
                                    </div>
                                </Panel>
                            </Panel>
                        </Page.Section>
                    </Page>
                </div>
            </div>
        </div>
            <FindProjectStaffDialog
                dialogName={DialogList.FIND_PERSON} 
                hideDialog={hideDialog}
                handleSelectedPerson={handleSelectedPerson}
                populatePersonList={getStaffingLandmen}
                personList={staffingLandmen}
                payPeriods={payPeriods}
                workClassifications={workClassifications}
                createMode={addingStaff}
                setSelectedProjectStaff={setSelectedProjectStaff}
                project={selectedProject}
                setPersonSearchTerm={setProjectStaffSearchTerm}
            />
            <FindLandmanDialog
                dialogName={DialogList.FIND_PROJECT_STAFF}
                hideDialog={hideDialog}
                handleSelectedPerson={handleSelectedPerson}
                populatePersonList={getLandmen}
                personList={landmen}
                payPeriods={payPeriods}
                workClassifications={workClassifications}
                createMode={addingStaff}
                setSelectedProjectStaff={setSelectedLandman}
                project={selectedProject}
                setPersonSearchTerm={setLandmanSearchTerm}
            />
            <FindClientDialog
                dialogName={DialogList.FIND_CLIENT}
                hideDialog={hideDialog}
                clients={clients}
                setClientSearchTerm={setClientSearchTerm}
                onCancel={onCancel}
                style={{maxHeight: '50vw'}}
                setSelectedClient={setSelectedClient}
            />
            <FindProjectDialog
                dialogName={DialogList.FIND_PROJECT}
                hideDialog={hideDialog}
                setProjectSearchTerm={setProjectSearchTerm}
                onCancel={onCancel}
                style={{maxHeight: '50vw'}}
                setSelectedProject={setSelectedProject}
                setSelectedClient={setSelectedClient}
                mileageRate={currentMileageRate}
                clientNumber={selectedClient?.clientNumber}
                dayRate={getDayRate()}
                clientTypes={projectTypes}
            />
        </>
    );
};

export default ProjectStaffingPage;



// WEBPACK FOOTER //
// ./src/components/client-project/pages/ProjectStaffing.tsx